(function (root) {
  if (root.TodayMerchStudioI18n) return;

  function normalizeLocale(value) {
    var base = String(value || '').trim().toLowerCase().replace(/_/g, '-').split('-')[0];
    return base === 'fr' || base === 'en' || base === 'de' ? base : '';
  }

  function isRecord(value) {
    return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
  }

  function validateEntries(entries, allowedFields) {
    if (!isRecord(entries)) return entries == null;
    return Object.keys(entries).every(function (id) {
      var entry = entries[id];
      return Boolean(id) && isRecord(entry) && Object.keys(entry).every(function (field) {
        return allowedFields.indexOf(field) >= 0 && typeof entry[field] === 'string';
      });
    });
  }

  function validateManifest(manifest) {
    var errors = [];
    if (!isRecord(manifest) || Number(manifest.version) !== 1) errors.push('version');
    var locales = isRecord(manifest && manifest.locales) ? manifest.locales : {};
    Object.keys(locales).forEach(function (locale) {
      if (locale !== 'fr' && locale !== 'en' && locale !== 'de') errors.push('locale:' + locale);
      var value = locales[locale];
      if (!isRecord(value)) {
        errors.push('locale-value:' + locale);
        return;
      }
      if (!validateEntries(value.placements, ['label'])) errors.push('placements:' + locale);
      if (!validateEntries(value.views, ['label', 'imageAlt'])) errors.push('views:' + locale);
    });
    return { valid: errors.length === 0, errors: errors };
  }

  function clone(value) {
    return value == null ? value : JSON.parse(JSON.stringify(value));
  }

  function localizeSourceLabel(source, locale) {
    if (locale !== 'de' || typeof source !== 'string') return source;
    // Exact French aliases already supported by product-marking-zone-key.liquid.
    var labels = { face: 'Vorderseite', 'face avant': 'Vorderseite', devant: 'Vorderseite', dos: 'Rückseite' };
    var key = source.trim().toLowerCase();
    return Object.prototype.hasOwnProperty.call(labels, key) ? labels[key] : source;
  }

  function localizedValue(manifest, locale, group, id, field, source) {
    var locales = isRecord(manifest && manifest.locales) ? manifest.locales : {};
    var exact = locales[locale] && locales[locale][group] && locales[locale][group][id];
    var french = locales.fr && locales.fr[group] && locales.fr[group][id];
    if (exact && typeof exact[field] === 'string' && exact[field] !== '') return exact[field];
    var fallback = french && typeof french[field] === 'string' && french[field] !== '' ? french[field] : source;
    return field === 'label' ? localizeSourceLabel(fallback, locale) : fallback;
  }

  function localizeConfig(source, manifest, requestedLocale) {
    var locale = normalizeLocale(requestedLocale);
    var result = clone(source || {});
    var supportedManifest = isRecord(manifest) && Number(manifest.version) === 1;
    var emptyManifest = manifest == null || isRecord(manifest) && Object.keys(manifest).length === 0;
    if (!locale || !supportedManifest && !(locale === 'de' && emptyManifest)) return result;
    (Array.isArray(result.placements) ? result.placements : []).forEach(function (placement) {
      var id = String(placement && placement.id || '');
      if (!id) return;
      placement.label = localizedValue(manifest, locale, 'placements', id, 'label', placement.label);
    });
    (Array.isArray(result.mediaViews) ? result.mediaViews : []).forEach(function (view) {
      var id = String(view && view.id || '');
      if (!id) return;
      view.label = localizedValue(manifest, locale, 'views', id, 'label', view.label);
      view.imageAlt = localizedValue(manifest, locale, 'views', id, 'imageAlt', view.imageAlt || view.alt);
      if (Object.prototype.hasOwnProperty.call(view, 'alt')) view.alt = view.imageAlt;
    });
    (Array.isArray(result.views) ? result.views : []).forEach(function (view) {
      var id = String(view && view.id || '');
      if (!id) return;
      view.label = localizedValue(manifest, locale, 'views', id, 'label', view.label);
      var imageAlt = localizedValue(manifest, locale, 'views', id, 'imageAlt', view.imageAlt || view.alt);
      if (Object.prototype.hasOwnProperty.call(view, 'imageAlt')) view.imageAlt = imageAlt;
      if (Object.prototype.hasOwnProperty.call(view, 'alt')) view.alt = imageAlt;
    });
    return result;
  }

  function parseNode(node) {
    if (!node) return {};
    try { return JSON.parse(node.textContent || '{}') || {}; } catch (error) { return {}; }
  }

  function findManifestNode(configNode) {
    if (!configNode) return null;
    var sectionId = configNode.getAttribute && configNode.getAttribute('data-section-id');
    var scope = configNode.parentElement || document;
    if (sectionId && scope.querySelector) {
      var escaped = root.CSS && typeof root.CSS.escape === 'function' ? root.CSS.escape(sectionId) : sectionId.replace(/"/g, '\\"');
      var matched = scope.querySelector('[data-todays-studio-i18n][data-section-id="' + escaped + '"]');
      if (matched) return matched;
    }
    return scope.querySelector && scope.querySelector('[data-todays-studio-i18n]')
      || document.querySelector && document.querySelector('[data-todays-studio-i18n]');
  }

  function localizeConfigNode(configNode, source) {
    var manifestNode = findManifestNode(configNode);
    var locale = manifestNode && manifestNode.getAttribute('data-locale')
      || document.documentElement && document.documentElement.lang
      || 'fr';
    return localizeConfig(source, parseNode(manifestNode), locale);
  }

  root.TodayMerchStudioI18n = {
    normalizeLocale: normalizeLocale,
    validateManifest: validateManifest,
    localizeConfig: localizeConfig,
    localizeConfigNode: localizeConfigNode
  };
})(window);
